import { render } from "./RankUp.vue?vue&type=template&id=19168ed3"
import script from "./RankUp.vue?vue&type=script&lang=js"
export * from "./RankUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__